<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span>{{ total }} Mandat<span v-if="total > 1">s</span></span>
        </h1>
      </template>
      <template slot="before-actions">
        <router-link
          v-if="isPromoteur && isAdmin"
          id="accessCreateButton"
          :to="{name: 'AccessCreate'}"
          class="page-header-btn is-small is-secondary is-widthFixToHeaderAccount">
          <!--<span class="icon is-medium"><i class="fas fa-plus-circle"></i></span>-->
          <span>Créer mandat</span>
        </router-link>
      </template>
    </page-nav-bar>

    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="true"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <template slot="left-col-small">
        <col-collapse-filter
          :has-filter="hasFilter"
          :loading="loading"
          @opened="openedCol = !openedCol"
          @resetFilters="resetFilters()">
          <div class="is-padding">
            <div
              v-if="isAdmin && isPromoteur"
              class="field">
              <div class="control">
                <multiselect
                  v-model="filters.account"
                  label="name"
                  track-by="pk"
                  :options="accountsAccess"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  @select="updateSimpleFilter"
                  :placeholder="''"
                  @remove="updateFilter([], 'account')"
                  @search-change="getUserAccounts">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="accountsAccess.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucune société trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Société</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Société</span>
                </multiselect>
              </div>
            </div>
            <div
              v-if="isAdmin"
              class="field">
              <div class="control">
                <multiselect
                  v-model="filters.program"
                  label="name"
                  track-by="pk"
                  :options="programsAccess"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  @select="updateSimpleFilter"
                  :placeholder="''"
                  @remove="updateFilter([], 'program')"
                  @search-change="getPrograms">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="programsAccess.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun programme trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Programme</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Programme</span>
                </multiselect>
              </div>
            </div>
            <div
              v-if="isAdmin && !isPromoteur"
              class="field">
              <div class="control">
                <multiselect
                  v-model="filters.promoteur"
                  label="name"
                  track-by="pk"
                  :options="promoteursAccess"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  @select="updateSimpleFilter"
                  :placeholder="''"
                  @remove="updateFilter([], 'promoteur')"
                  @search-change="getUserPromoteur">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="promoteursAccess.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Promoteur</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Promoteur</span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <date-picker
                  :model="{start_date__gte: filters.start_date__gte, start_date__lte: filters.start_date__lte}"
                  :style-version="2"
                  :is-range="true"
                  :name="'date'"
                  :placeholder="'Début de mandat'"
                  :config="{mode: 'range'}"
                  @input="Object.assign(filters, $event); updateSimpleFilter()" />
              </div>
            </div>
            <div class="field">
              <div class="control">
                <date-picker
                  :model="{end_date__gte: filters.end_date__gte, end_date__lte: filters.end_date__lte}"
                  :style-version="2"
                  :is-range="true"
                  :name="'date'"
                  :placeholder="'Fin de mandat'"
                  :config="{mode: 'range'}"
                  @input="Object.assign(filters, $event); updateSimpleFilter()" />
              </div>
            </div>
          </div>
        </col-collapse-filter>
      </template>
      <list-top-bar
        :has-filtered="hasFilter"
        :counted="count"
        label="mandat(s)"
        :not-export-all="true"
        :is-conditioned="true"
        :child-action-group="parentActionGroup"
        @update:childActionGroup="handleActionGroupUpdate">
      </list-top-bar>
      <div class="is-border-left is-border-right is-border-bottom">
        <div
          style="justify-content: flex-end"
          class="is-flex has-background-white"
          :class="parentActionGroup ? 'is-border-bottom': ''">
          <div
            style="flex-shrink: 0; align-items: stretch; z-index: 1"
            class="is-flex is-nowrap">
            <div
              class="column is-paddingless is-border-left container-btn-export-access"
              v-if="multiselection && parentActionGroup && isAdmin && isPromoteur">
              <a
                :style="selectedItems.length ? 'background-color: #DB534D; color: white; cursor: pointer' : 'cursor: default; color: #D7D7D7'"
                @click="selectedItems.length ? deleteMany() : ''"
                class="btn-export_access is-uppercase">
                <span class="icon"><i class="fas fa-trash-alt"></i></span>
                <span>Supprimer Mandats</span>
              </a>
            </div>
          </div>
        </div>
        <filters-tags
          id="user-tag"
          :has-filter="hasFilter"
          :filters="filters"
          @reset="resetFilters"
          @update="updateFromTag($event)" />
        <spinner-round
          v-if="loading"
          :is-loading="loading" />
        <table-controls-vue
          v-if="!loading && items.length"
          :has-sticky="true"
          :no-scroll-direction="true">
          <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-small has-actionsontd">
            <thead class="has-cells-vcentered">
              <tr class="is-size-6">
                <th class="has-text-centered">
                </th>
                <th v-if="isPromoteur">
                  <sortable
                    sort-id="account"
                    :sort="sortBy.account"
                    label="Société"
                    @sort="sort('account', $event)" />
                </th>
                <th>
                  <span>Programme</span>
                  <!-- <sortable
                    sort-id="program__name"
                    :sort="sortBy.program__name"
                    label="Programme"
                    @sort="sort('program__name', $event)" /> -->
                </th>
                <th v-if="!isPromoteur">
                  <sortable
                    sort-id="promoteur"
                    :sort="sortBy.promoteur"
                    label="Promoteur"
                    @sort="sort('promoteur', $event)" />
                </th>
                <th>
                  <sortable
                    sort-id="start_date"
                    :sort="sortBy.start_date"
                    label="Date de début"
                    @sort="sort('start_date', $event)" />
                </th>
                <th>
                  <sortable
                    sort-id="end_date"
                    :sort="sortBy.end_date"
                    label="Date de fin"
                    @sort="sort('end_date', $event)" />
                </th>
                <th>
                  <sortable
                    sort-id="remuneration"
                    :sort="sortBy.remuneration"
                    label="Taux rémunération HT"
                    @sort="sort('remuneration', $event)" />
                </th>
                <th
                  v-if="isPromoteur"
                  class="has-text-centered" />
              </tr>
            </thead>
            <tbody class="has-cells-vcentered">
              <tr>
                <td
                  v-if="multiselection"
                  colspan="7"
                  style="padding: 0">
                  <div
                    class="is-flex is-nowrap is-align-items-center container_select_multiple_access">
                    <a
                      :style="!selectedItems.length > 0? 'background-color: #219CED' : 'background-color: #8CBB7D'"
                      class="select_multiple_access"
                      @click="$store.commit('selectAllMultiselectionItems')">
                      <i
                        style="font-size: 17px; padding: 0px 22px 0px 16px"
                        class="far fa-check-double"></i>
                      <span class="is-padding-left-xxsmall">{{ !selectedItems.length > 0 ? 'Cliquez ici pour sélectionner toutes les lignes de la page' : 'Déselectionnez toutes les lignes de la page' }}</span>
                    </a>
                  </div>
                </td>
              </tr>
              <tr
                v-for="(access, i) in items"
                :id="'e' + access.pk"
                :key="access.pk"
                class="is-size-6">
                <td class="has-text-centered">
                  <span v-if="!multiselection">
                    <span v-if="isPromoteur">
                      <avatar
                        :item="access.account"
                        :i="i" />
                    </span>
                    <span v-else>
                      <avatar
                        :item="access.promoteur"
                        :i="i" />
                    </span>
                  </span>
                  <multiselect-button
                    v-else
                    :data="access" />
                </td>
                <td
                  v-if="isPromoteur && access.account && !access.accounts"
                  class="is-cell-hoverable">
                  <router-link :to="{name: 'CompanyVue', params: {id: access.account.pk}}">
                    {{ access.account.name | truncate }}
                  </router-link>
                </td>
                <td
                  v-if="isPromoteur && access.accounts"
                  class="is-cell-hoverable">
                  <router-link :to="{name: 'ChannelVue', params: {id: access.sales_channel.pk}}">
                    Canal de vente: {{ access.sales_channel.name }}
                  </router-link>
                </td>
                <td
                  v-if="access.program"
                  class="is-cell-hoverable">
                  <router-link :to="{name: 'ProgramVue', params: {id: access.program.pk}}">
                    {{ access.program.name }}
                  </router-link>
                </td>
                <td
                  class="is-cell-hoverable"
                  v-if="!isPromoteur && isPromoteurDetailsActivated(access) && access.program">
                  <router-link
                    class="is-linkTextPicto"
                    :to="{name: 'PromoteurPresentation', params: {id: access.promoteur.pk}}">
                    {{ access.promoteur.name }}
                  </router-link>
                </td>
                <td v-if="!isPromoteur && !isPromoteurDetailsActivated(access)">
                  {{ access.promoteur.name }}
                </td>
                <td>
                  {{ access.start_date|prettyDate }}
                </td>
                <td>
                  {{ access.end_date|prettyDate }}
                </td>
                <td>
                  {{ access.remuneration }}
                </td>
                <td v-if="isPromoteur && access.account && !access.accounts">
                  <display-button-list
                    :buttons="buttonList"
                    :data="access" />
                </td>
                <td v-if="isPromoteur && access.accounts">
                  <display-button-list
                    :buttons="buttonList2"
                    :data="access.sales_channel" />
                </td>
              </tr>
            </tbody>
          </table>
        </table-controls-vue>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucun mandat disponible
            </h2>
            <a
              v-if="hasFilter"
              class="has-text-primary"
              @click="resetFilters"><span class="icon"><i class="fas fa-undo-alt" /></span> <span>Réinitialiser les filtres</span></a>
          </div>
        </div>
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadItems($event); askRemoveSelection = false;" />
      </div>
    </page-content>
  </div>
</template>

<script>
import moment from 'moment'
import { GenericList, Filter, Sort, DefaultValues, FilterGetter, Access, Multiselection } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'AccessList',
  mixins: [GenericList, Filter, Sort, DefaultValues, FilterGetter, Access, Multiselection],
  data () {
    return {
      deleteTitle: 'Suppression mandat',
      deleteText: 'La société n\'aura plus accès au programme, cette action entrainera également l\'annulation de ses options sur ce programme.',
      moment: moment(),
      filters: {
        account: null,
        promoteur: null,
        program: null,
        start_date__gte: null,
        start_date__lte: null,
        end_date__gte: null,
        end_date__lte: null
      },
      initFilters: {
        account: null,
        promoteur: null,
        program: null,
        start_date__gte: null,
        start_date__lte: null,
        end_date__gte: null,
        end_date__lte: null
      },
      buttonList: [
        {
          action: (id) => {
            this.deleteAccess(id)
          },
          icon: 'fa-trash-alt',
          // text: 'Supprimer',
          needProfile: ['admin'],
          display: (o) => {
            return this.isPromoteur
          }
        }
      ],
      buttonList2: [
        {
          action: (id) => {
            this.$router.push({ name: 'ChannelVue', params: { id } })
          },
          icon: 'fa-eye'
          // text: 'Supprimer',
        }
      ],
      loadDocuments: this.loadItems,
      items: [],
      service: 'ACCESS_AND_MANDAT',
      accounts: [],
      promoteurs: [],
      programs: [],
      openedCol: false,
      askRemoveSelection: false,
      parentActionGroup: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur']),
    ...mapState({
      savedFilters: 'savedFilters',
      currentUser: 'currentUser',
      accountsList: 'accounts'
    }),
    today () {
      return moment()
    }
  },
  created () {
    if ('accessList' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
    }
    this.cancelSelect()
  },
  methods: {
    initSavedFilters () {
      this.filters = cloneDeep(this.savedFilters.accessList)
      this.updateSimpleFilter()
    },
    isPromoteurDetailsActivated (access) {
      let result = false
      if (this.accountsList.length > 0) {
        result = this.accountsList.find(a => a.name === access.promoteur.name && a.promoteur_details_activated).promoteur_details_activated
      }
      return result
    },
    /**
      * upadate query before get
      */
    beforeGet () {
      if (this.query.account && this.query.account.pk) {
        this.query.account = this.query.account.pk
      }
      if (this.query.program && this.query.program.pk) {
        this.query.program = this.query.program.pk
      }
      if (this.query.promoteur && this.query.promoteur.pk) {
        this.query.promoteur = this.query.promoteur.pk
      }
      if (this.query.end_date__lte) {
        this.query.end_date__lte = moment(this.query.end_date__lte).endOf('day').toISOString()
      }
      if (this.query.start_date__lte) {
        this.query.start_date__lte = moment(this.query.start_date__lte).endOf('day').toISOString()
      }
      if (this.query.start_date__gte) {
        this.query.start_date__gte = moment(this.query.start_date__gte).startOf('day').toISOString()
      }
      if (this.query.end_date__gte) {
        this.query.end_date__gte = moment(this.query.end_date__gte).startOf('day').toISOString()
      }
      for (let key in this.filters) {
        this.$store.commit('setSavedFilters', { from: 'accessList', name: key, value: this.filters[key] })
      }
    },
    askRemove () {
      this.askRemoveSelection = true
    },
    cancelRemove () {
      this.askRemoveSelection = false
    },
    async deleteMany () {
      let deleted = await this.$swal({
        title: 'Suppression mandat',
        text: 'La société n\'aura plus accès au programme, cette action entrainera également l\'annulation de ses options sur ce programme.',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (deleted.dismiss) return false
      if (deleted) {
        try {
          let listId = []
          for (const item of this.selectedItems) {
            listId.push(item)
          }
          await this.$api.axios.delete(this.$resources.ACCESS, { data: { pk: listId } })
          this.$store.commit('setSelectedItems', [])
          this.$store.commit('setMultiselection', false)
          this.askRemoveSelection = false
          this.loadItems()
          this.initSavedFilters()
          this.$toasted.global.success('Séléction supprimée.')
          this.cancelSelect()
          this.parentActionGroup = false
        } catch (e) {
          this.cancelSelect()
          this.parentActionGroup = false
          console.log(e)
          this.$toasted.global.danger('Erreur lors de la suppresion.')
        }
      }
    },
    reload () {
      this.initSavedFilters()
    },
    async deleteAccess (id) {
      try {
        await this.$api.delete(this.$resources.ACCESS, id)
        this.$toasted.global.success('mandat supprimé.')
        this.loadItems()
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de la suppresion.')
      }
    },
    cancelSelect () {
      this.parentActionGroup = false
      this.$store.commit('cancelMultiselection')
    },
    handleActionGroupUpdate (newValue) {
      this.parentActionGroup = newValue
    }
  }
}
</script>

<style lang="sass">
.container-btn-export-access
  width: 217px
  height: 52px
  flex: 0 0 auto

.btn-export_access
  background-color: #fff
  color: #7a7a7a
  width: 100%
  min-height: 100%
  font-size: 1.2rem
  display: flex
  align-items: center
  justify-content: center

.container_select_multiple_access
  width: 100%

.select_multiple_access
  text-decoration: none !important
  padding: 13px
  width: 100%
  color: white

.select_multiple_access:hover
  color: white
  text-decoration: none
</style>
